import api from "../commonApi";
import { extend } from "@/utils/commonUtil";
/*
负责管理除UI之外的所有所有非响应式数据和不跟ui有关的逻辑处理层，api请求及api请求会的响应数据处理。尽量在具体的vue实例里只负责拿到数据，
再经过一个ui框架和数据之间的一个适配方法如util里的elementDataAdaptor里的方法就可以将数据渲染到页面上。
*/
const moduleService: Record<string | number, any> = {
  name: "commonService", //名字与模块的文件夹名字保持一致
};

extend(moduleService, api, false, false);

export default moduleService;
